import Selection from "../../../../../../core-lib/js/Selection/Selection";

export default class Carousel {
	constructor(el) {
		this.el = new Selection(el);
		this.pagination = new Selection(".swiper-pagination", this.el.parent());
		this.initSwiper();
	}

	initSwiper() {
		this.swiper = new Swiper(this.el.get(0), {
			speed: 2000,
			// autoHeight: true,
			spaceBetween: 20,
			pagination: {
				el: this.pagination.get(0),
				type: "bullets",
				clickable: true,
			},
			keyboard: {
				enabled: true,
				onlyInViewport: true,
			},
			direction: "horizontal",
			// loop: true,
			watchOverflow: true,
			// autoplay: true,
		});
	}
}
